'use client';

import { c as _c } from "react/compiler-runtime";
import { Indicator as CheckboxIndicator, Root as CheckboxRoot } from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';
type CheckboxProperties = ComponentProps<typeof CheckboxRoot>;
function Checkbox(t0) {
  const $ = _c(9);
  let className;
  let properties;
  if ($[0] !== t0) {
    ({
      className,
      ...properties
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = properties;
  } else {
    className = $[1];
    properties = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("peer border-input dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckboxIndicator data-slot="checkbox-indicator" className="flex items-center justify-center text-current transition-none"><CheckIcon className="size-3.5" /></CheckboxIndicator>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== properties || $[7] !== t1) {
    t3 = <CheckboxRoot data-slot="checkbox" className={t1} {...properties}>{t2}</CheckboxRoot>;
    $[6] = properties;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export { Checkbox };